import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
export var CombineOrdersIA = function CombineOrdersIA(_ref) {
  var shipInternational = _ref.shipInternational;
  if (shipInternational) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "9Brnnd",
      defaultMessage: [{
        "type": 0,
        "value": "Pour combiner des commandes expédiées à l'international, vous devez modifier l'une des commandes et y ajouter tous les articles de l'autre commande. Une fois que vous avez terminé, vous pouvez annuler la deuxième commande et tout expédier en une seule fois. Attention : vous ne pouvez pas combiner des commandes prêtes à expédier avec des précommandes."
      }]
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Nmy24O",
      defaultMessage: [{
        "type": 0,
        "value": "Vous ne pouvez pas combiner plus de deux commandes pour l'instant. Si vous avez besoin d'aide, contactez-nous ci-dessous. Nous pouvons ajouter pour vous les mêmes informations de suivi à plusieurs commandes. Ainsi, votre client pourra accéder aux informations de suivi, et les envois seront mis à jour avec précision."
      }]
    })));
  }
};